import React from "react";

import ClassroomImg from "../../../assets/images/classroom.png";
import GroupClass from "../../../organisms/teacher/GroupClass";
import TeacherHeader from "../../../organisms/teacher/TeacherHeader";
import { IGrade } from "../../../pages/teacher/types";
import { IClass } from "../../../state";

import styles from "./ClassList.module.scss";

export type Props = {
  classes: IClass[];
};

const links = [{ name: "クラス登録", to: "#" }];

const ClassList: React.FC<Props> = ({ classes }) => {
  const listClass = React.useMemo(() => {
    const grades: IGrade[] = [];
    classes.forEach(cls => {
      if (!grades.find(item => item.grade === cls.grade)) {
        grades.push({
          grade: cls.grade,
          classes: [
            {
              id: cls.id,
              name: cls.full_name,
              charged: cls.charged,
              assumed_entrance_year: cls.assumed_entrance_year,
            },
          ],
        });
      } else {
        const index = grades.findIndex(item => item.grade === cls.grade);
        grades[index].classes.push({
          id: cls.id,
          name: cls.full_name,
          charged: cls.charged,
          assumed_entrance_year: cls.assumed_entrance_year,
        });
      }
    });
    return grades;
  }, [classes]);

  return (
    <>
      <TeacherHeader links={links} />
      <div className={styles.wrapper}>
        <div className={styles.groupCheck}>
          <img src={ClassroomImg} alt="class-room" />
          <p>登録済みクラス一覧</p>
        </div>
        <GroupClass listClass={listClass} forward />
      </div>
    </>
  );
};

export default ClassList;
